import { ClassTypes, DataTypes, RelatedClassCardinality } from '../model/enumerations';
import MxEnum from '../../../Utils/MxEnum';

SchemaServiceEnums.$inject = [];
export function SchemaServiceEnums() {
	return {
		ClassTypes: new MxEnum(ClassTypes),
		DataTypes: new MxEnum(DataTypes),
		RelationCardinality: new MxEnum(mx.SolutionBuilderAgent.RelationCardinality),
		RelatedClassCardinality: new MxEnum(RelatedClassCardinality),
	};
}
